/* INTEGY V545 — browser Back/return-state owner.
   Goals:
   1) Search -> result/product -> Back restores the exact collection/search position.
   2) Quick Shop and Add-to-Cart flyouts participate in browser history, so Back
      dismisses the transient UI instead of abandoning the page.
   3) Navigating out of a transient UI consumes its synthetic history entry first,
      keeping the browser stack clean: source page -> destination page.
*/
(function () {
  'use strict';
  if (window.IntegyV545NavigationState) return;

  function v626Root(){
    try { var r=window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root; if(r) return r.charAt(r.length-1)==='/'?r:r+'/'; } catch(error) {}
    return '/';
  }
  var STATE_KEY = 'integyV545';
  var VERSION = 1;
  var observer = null;
  var syncTimer = 0;
  var scrollTimer = 0;
  var restoring = false;
  var historyMovePending = false;
  var deferredNavigation = null;
  var lastDomStack = [];
  var userInteracted = false;

  function q(selector, scope) {
    try { return (scope || document).querySelector(selector); } catch (error) { return null; }
  }
  function qa(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); } catch (error) { return []; }
  }
  function currentUrl() {
    return String(location.pathname || '') + String(location.search || '') + String(location.hash || '');
  }
  function clone(value) {
    try { return JSON.parse(JSON.stringify(value || {})); } catch (error) { return {}; }
  }
  function stateData() {
    var raw = history.state && history.state[STATE_KEY];
    if (!raw || raw.version !== VERSION) return null;
    return raw;
  }
  function stateStack() {
    var data = stateData();
    return data && Array.isArray(data.stack) ? data.stack.slice() : [];
  }
  function sameStack(a, b) {
    if (!a || !b || a.length !== b.length) return false;
    for (var i = 0; i < a.length; i += 1) if (a[i] !== b[i]) return false;
    return true;
  }
  function isPrefix(prefix, full) {
    if (!prefix || !full || prefix.length > full.length) return false;
    for (var i = 0; i < prefix.length; i += 1) if (prefix[i] !== full[i]) return false;
    return true;
  }
  function productPath(value) {
    try {
      var url = new URL(value, location.origin);
      var match = url.pathname.match(/\/products\/([^/?#]+)/i);
      return match ? v626Root() + 'products/' + match[1].toLowerCase() : '';
    } catch (error) { return ''; }
  }
  function anchorSnapshot() {
    var cards = qa('[data-productgrid-items] [data-product-item],[data-productgrid-items] .productgrid--item,.integy-v520-search-card,.integy-v529-search-card');
    var header = q('.site-header');
    var topBoundary = header ? Math.max(0, Math.round(header.getBoundingClientRect().bottom)) : 90;
    var chosen = null;
    for (var i = 0; i < cards.length; i += 1) {
      var rect = cards[i].getBoundingClientRect();
      if (rect.bottom >= topBoundary + 8) { chosen = cards[i]; break; }
    }
    if (!chosen) return {};
    var link = q('a[href*="/products/"]', chosen);
    var sku = chosen.getAttribute('data-sku') || (q('[data-sku],.integy-product-card-sku,.productitem--sku', chosen) || {}).textContent || '';
    sku = String(sku || '').replace(/^\s*SKU:\s*/i, '').trim();
    return {
      anchorPath: productPath(link && link.getAttribute('href') || ''),
      anchorSku: sku,
      anchorTop: Math.round(chosen.getBoundingClientRect().top)
    };
  }
  function writeState(stack, options) {
    options = options || {};
    var existing = clone(history.state);
    var previous = existing[STATE_KEY] && existing[STATE_KEY].version === VERSION ? existing[STATE_KEY] : {};
    var snapshot = options.keepPosition ? {} : anchorSnapshot();
    var data = {
      version: VERSION,
      pageUrl: currentUrl(),
      stack: (stack || []).slice(),
      scrollY: options.keepPosition && Number.isFinite(Number(previous.scrollY))
        ? Number(previous.scrollY)
        : Math.max(0, Math.round(window.scrollY || window.pageYOffset || 0)),
      anchorPath: options.keepPosition ? (previous.anchorPath || '') : (snapshot.anchorPath || ''),
      anchorSku: options.keepPosition ? (previous.anchorSku || '') : (snapshot.anchorSku || ''),
      anchorTop: options.keepPosition && Number.isFinite(Number(previous.anchorTop))
        ? Number(previous.anchorTop)
        : (Number.isFinite(Number(snapshot.anchorTop)) ? Number(snapshot.anchorTop) : 0),
      timestamp: Date.now()
    };
    existing[STATE_KEY] = data;
    if (options.push) history.pushState(existing, '', location.href);
    else history.replaceState(existing, '', location.href);
    return data;
  }
  function snapshotPage() {
    if (stateStack().length) return stateData();
    return writeState([], { push: false, keepPosition: false });
  }

  function searchOpen() {
    return document.documentElement.classList.contains('integy-v446-search-open') ||
      !!q('.live-search--takeover.active,.live-search--takeover.visible,[data-animation-state="open"].live-search--takeover');
  }
  function quickshopOpen() {
    return !!(document.body && document.body.classList.contains('modal-visible') && q('[data-modal-container].modal--quickshop-full,.modal--quickshop-full[data-modal-container]'));
  }
  function atcOpen() {
    return !!q('[data-atc-banner][data-animation-state="open"],.atc-banner--container[data-animation-state="open"]');
  }
  function domStack() {
    var stack = [];
    if (searchOpen()) stack.push('search');
    if (quickshopOpen()) stack.push('quickshop');
    /* On a full product page, Back should leave the product and return to the
       collection/search source in one press even when the ATC banner is open.
       The banner's own Close button still dismisses it without navigation. */
    if (atcOpen() && !(document.body && document.body.classList.contains('template-product'))) stack.push('atc');
    return stack;
  }

  function closeSearch() {
    if (!searchOpen()) return;
    var owner = window.IntegyV520CommerceOwner || window.IntegyV501CommerceOwner || window.IntegyV495CommerceOwner;
    if (owner && typeof owner.close === 'function') {
      try { owner.close({ skipFocus: true }); return; } catch (error) {}
    }
    var button = q('[data-live-search-takeover-cancel],.integy-v464-search-close');
    if (button) { try { button.click(); } catch (error) {} }
  }
  function closeQuickshop() {
    if (!quickshopOpen()) return;
    var modal = q('[data-modal-container].modal--quickshop-full,.modal--quickshop-full[data-modal-container]');
    var button = modal && q('[data-modal-close],.modal-close', modal);
    if (button) { try { button.click(); } catch (error) {} }
  }
  function closeAtc() {
    var banner = q('[data-atc-banner][data-animation-state="open"],.atc-banner--container[data-animation-state="open"]');
    if (!banner) return;
    var button = q('[data-atc-banner-close],.atc-banner--close', banner);
    if (button) { try { button.click(); } catch (error) {} }
  }
  function reconcileToStack(target) {
    restoring = true;
    try {
      if (target.indexOf('atc') < 0) closeAtc();
      if (target.indexOf('quickshop') < 0) closeQuickshop();
      if (target.indexOf('search') < 0) closeSearch();
    } finally {
      window.setTimeout(function () { restoring = false; scheduleSync(); }, 90);
    }
  }

  function pushOverlay(type) {
    var hist = stateStack();
    if (hist[hist.length - 1] === type) return;
    if (!hist.length) snapshotPage();
    hist = stateStack();
    hist.push(type);
    writeState(hist, { push: true, keepPosition: true });
  }

  function replaceTopOverlay(type) {
    var hist = stateStack();
    if (!hist.length) {
      pushOverlay(type);
      return;
    }
    hist[hist.length - 1] = type;
    writeState(hist, { push: false, keepPosition: true });
  }

  function consumeOverlayEntries(count, after) {
    var hist = stateStack();
    count = Math.min(Math.max(0, count || hist.length), hist.length);
    if (!count) { if (after) after(); return; }
    if (historyMovePending) return;
    historyMovePending = true;
    deferredNavigation = after || null;
    try { history.go(-count); }
    catch (error) {
      historyMovePending = false;
      var fn = deferredNavigation; deferredNavigation = null;
      if (fn) fn();
    }
  }

  function syncHistoryToDom() {
    syncTimer = 0;
    if (restoring || historyMovePending) return;
    var dom = domStack();
    var hist = stateStack();

    /* Add-to-cart replaces Quick Shop as the active transient layer. This gives
       one Back press after Add to Cart: cart confirmation -> original grid. */
    if (atcOpen() && hist.length && hist[hist.length - 1] === 'quickshop') {
      restoring = true;
      closeQuickshop();
      replaceTopOverlay('atc');
      window.setTimeout(function () { restoring = false; scheduleSync(); }, 90);
      lastDomStack = domStack();
      return;
    }

    if (sameStack(dom, hist)) { lastDomStack = dom; return; }

    if (isPrefix(hist, dom) && dom.length > hist.length) {
      for (var i = hist.length; i < dom.length; i += 1) pushOverlay(dom[i]);
      lastDomStack = dom;
      return;
    }

    if (isPrefix(dom, hist) && hist.length > dom.length) {
      /* A close button/Escape closed a transient UI. Consume the synthetic
         history entry so the next browser Back actually goes to the prior page. */
      consumeOverlayEntries(hist.length - dom.length);
      lastDomStack = dom;
      return;
    }

    /* Same depth but a transition occurred (notably Quick Shop -> ATC). */
    if (hist.length === dom.length && hist.length) {
      writeState(dom, { push: false, keepPosition: true });
      lastDomStack = dom;
      return;
    }

    lastDomStack = dom;
  }
  function scheduleSync() {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncHistoryToDom, 45);
  }

  function matchingCard(data) {
    if (!data) return null;
    var cards = qa('[data-productgrid-items] [data-product-item],[data-productgrid-items] .productgrid--item,.integy-v520-search-card,.integy-v529-search-card');
    for (var i = 0; i < cards.length; i += 1) {
      var sku = String(cards[i].getAttribute('data-sku') || '').trim();
      if (data.anchorSku && sku && sku.toLowerCase() === String(data.anchorSku).toLowerCase()) return cards[i];
      var link = q('a[href*="/products/"]', cards[i]);
      if (data.anchorPath && link && productPath(link.getAttribute('href') || '') === data.anchorPath) return cards[i];
    }
    return null;
  }
  function restorePosition(data) {
    if (!data || userInteracted) return;
    var card = matchingCard(data);
    var y = Math.max(0, Number(data.scrollY || 0));
    if (card) {
      var savedTop = Number(data.anchorTop || 0);
      var rect = card.getBoundingClientRect();
      y = Math.max(0, (window.scrollY || window.pageYOffset || 0) + rect.top - savedTop);
    }
    try { window.scrollTo(0, Math.round(y)); } catch (error) {}
  }
  function scheduleRestore(data) {
    if (!data || data.stack && data.stack.length) return;
    userInteracted = false;
    [0, 60, 160, 360, 700, 1200, 1900].forEach(function (delay) {
      window.setTimeout(function () { restorePosition(data); }, delay);
    });
  }
  function backForwardNavigation() {
    try {
      var entries = performance && performance.getEntriesByType ? performance.getEntriesByType('navigation') : [];
      return !!(entries && entries[0] && entries[0].type === 'back_forward');
    } catch (error) { return false; }
  }

  function targetUrlFromForm(form) {
    try {
      var action = new URL(form.action || location.href, location.origin);
      var method = String(form.method || 'get').toLowerCase();
      if (method !== 'get') return '';
      var params = new URLSearchParams(new FormData(form));
      action.search = params.toString();
      return action.href;
    } catch (error) { return ''; }
  }
  function isTransientNode(node) {
    if (!node || !node.closest) return false;
    return !!node.closest('.live-search--takeover,.modal--quickshop-full,[data-atc-banner][data-animation-state="open"],.atc-banner--container[data-animation-state="open"]');
  }
  function navigateAfterConsuming(url) {
    if (!url) return;
    consumeOverlayEntries(stateStack().length, function () { location.assign(url); });
  }

  document.addEventListener('click', function (event) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var target = event.target && event.target.closest ? event.target.closest('a[href]') : null;
    if (!target || target.target === '_blank') return;

    /* Always refresh the base-page return anchor just before leaving a product grid. */
    if (!stateStack().length && target.closest('[data-product-item],.productgrid--item,.integy-v520-search-card,.integy-v529-search-card')) snapshotPage();

    var stack = stateStack();
    if (!stack.length || !isTransientNode(target)) return;
    if (target.matches('[data-modal-close],[data-atc-banner-close],[data-live-search-takeover-cancel],.modal-close,.atc-banner--close,.integy-v464-search-close')) return;
    var href = target.getAttribute('href') || '';
    if (!href || /^#|^javascript:/i.test(href)) return;
    var url;
    try { url = new URL(href, location.origin); } catch (error) { return; }
    if (url.href === location.href) return;
    event.preventDefault();
    event.stopPropagation();
    navigateAfterConsuming(url.href);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches) return;
    var stack = stateStack();
    if (!stack.length || !isTransientNode(form)) return;

    if (form.matches('form[action*="/search"],form[role="search"]')) {
      var input = q('input[type="search"][name="q"],input[name="q"]', form);
      if (!input || !String(input.value || '').trim()) return;
      var searchUrl = targetUrlFromForm(form);
      if (!searchUrl) return;
      event.preventDefault();
      event.stopPropagation();
      consumeOverlayEntries(stack.length, function () { location.assign(searchUrl); });
      return;
    }

    if (form.closest('[data-atc-banner],.atc-banner--container') && !/\/cart\/add/i.test(form.action || '')) {
      event.preventDefault();
      event.stopPropagation();
      consumeOverlayEntries(stack.length, function () {
        try { HTMLFormElement.prototype.submit.call(form); } catch (error) { form.submit(); }
      });
    }
  }, true);

  window.addEventListener('popstate', function () {
    var target = stateStack();
    var fn = deferredNavigation;
    deferredNavigation = null;
    historyMovePending = false;
    reconcileToStack(target);
    var data = stateData();
    if (!target.length && data) scheduleRestore(data);
    if (fn) window.setTimeout(fn, 0);
  });

  window.addEventListener('pageshow', function (event) {
    var data = stateData();
    if (!data) data = writeState([], { push: false, keepPosition: false });
    reconcileToStack(data.stack || []);
    if (event.persisted || backForwardNavigation()) scheduleRestore(data);
  });

  window.addEventListener('pagehide', function () {
    if (!stateStack().length) snapshotPage();
  });
  window.addEventListener('scroll', function () {
    if (stateStack().length) return;
    window.clearTimeout(scrollTimer);
    scrollTimer = window.setTimeout(snapshotPage, 140);
  }, { passive: true });
  ['pointerdown','touchstart','wheel','keydown'].forEach(function (name) {
    window.addEventListener(name, function () { userInteracted = true; }, { passive: true });
  });

  function boot() {
    if (!stateData()) writeState([], { push: false, keepPosition: false });
    lastDomStack = domStack();
    scheduleSync();
    if (window.MutationObserver) {
      observer = new MutationObserver(function () { scheduleSync(); });
      observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
      if (document.body) observer.observe(document.body, { attributes: true, attributeFilter: ['class','data-animation-state'], childList: true, subtree: true });
    }
  }

  window.IntegyV545NavigationState = {
    snapshot: snapshotPage,
    restore: function () { scheduleRestore(stateData()); },
    stack: stateStack,
    sync: scheduleSync
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
}());
